document.addEventListener('DOMContentLoaded', function () {

  const addToCartWrapper = document.querySelector('.purchase-details__buttons');

  if (addToCartWrapper && window.innerWidth < 481) {

    const productForm = document.querySelector('.shopify-product-form');
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        addToCartWrapper.classList.remove('purchase-details__buttons--sticky');
      } else {
        addToCartWrapper.classList.add('purchase-details__buttons--sticky');
      }
    }, observerOptions);
    
    observer.observe(productForm);
  }
});